import { render, staticRenderFns } from "./createPaxelRecycleHowTo.vue?vue&type=template&id=415b27f0&"
import script from "./createPaxelRecycleHowTo.vue?vue&type=script&lang=js&"
export * from "./createPaxelRecycleHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports